module.exports = __webpack_public_path__ + "img/orange_fruit.be5030ca.webp";